exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cell-wrap-text {\n  white-space: normal !important;\n}", ""]);

// exports
